
const servicesSwiper = new Swiper("[data-swiper-services-3]", {
  slidesPerView: 1, // Default slides per view
  spaceBetween:30, // Space between slides
  loop: true,
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // When window width is >= 768px (desktop)
    991: {
      slidesPerView: 4,
       spaceBetween:10,
    },
     768: {
      slidesPerView: 1,
    },
  },
});
const collSwiper = new Swiper("[data-swiper-coll-3]", {
  slidesPerView: 2, // Default slides per view
  spaceBetween:15, // Space between slides
  loop: true,
   navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // When window width is >= 768px (desktop)
    991: {
      slidesPerView: 4,
       spaceBetween:50,
    },
     768: {
      slidesPerView: 2,
    },
  },
});
document.addEventListener("DOMContentLoaded", function () {
  $('.main-media-container').slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    dots: false,
    asNavFor: '.main-media-container-thumbs',
    prevArrow: $('.swiper-button-prev'),
    nextArrow: $('.swiper-button-next')
 });
  $('.main-media-container-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-media-container',
    dots: false,
    focusOnSelect: true,
    variableWidth: true
  });
  // Remove active class from all thumbnail slides
  $('.main-media-container-thumbs .slick-slide').removeClass('slick-active');
  // Set active class to first thumbnail slides
  $('.main-media-container-thumbs .slick-slide').eq(0).addClass('slick-active');
  // On before slide change match active thumbnail to current slide
  $('.main-media-container').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  $('.main-media-container-thumbs .slick-slide').removeClass('slick-active');
  $('.main-media-container-thumbs .slick-slide').eq(mySlideNumber).addClass('slick-active');
});

    
 

  $('[data-fancybox="gallery"]').fancybox({
    arrows: true,
    keyboard: true,
    infobar: false,
    toolbar: true,
    buttons: ["zoom", "fullScreen", "close"],
  });
});
$( document ).ready(function() {
  
   $(".featured_products_container").slick({
   infinite: true,
    speed: 500,
     centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
     ariableWidth: true,
    dots: false,
     arrows:false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); 
    $(".product-list").slick({
   infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); 
});

document.addEventListener("DOMContentLoaded", () => {
  // --- Hero slides ---
  const slides = document.querySelectorAll(".hero-slide");
  if(!slides.length) return;
  let slideIndex = 0;
  slides[0].classList.add("active");
  setInterval(() => {
    slides[slideIndex].classList.remove("active");
    slideIndex = (slideIndex + 1) % slides.length;
    slides[slideIndex].classList.add("active");
  }, 10000);

  // --- Typing effect ---
  const typingEl = document.querySelector(".typing");
  const text = typingEl?.dataset.text || "";
  let i = 0, isDeleting = false;

  function type() {
    if (!typingEl) return;
    if (!isDeleting && i <= text.length) {
      typingEl.textContent = text.substring(0, i);
      i++;
      setTimeout(type, 150);
    } else if (isDeleting && i >= 0) {
      typingEl.textContent = text.substring(0, i);
      i--;
      setTimeout(type, 100);
    } else {
      isDeleting = !isDeleting;
      setTimeout(type, 1000);
    }
  }
  if (typingEl) type();
});

document.addEventListener("DOMContentLoaded", () => {

  function initScrollAnimations(context = document) {
    const items = context.querySelectorAll(".animate-on-scroll");
    if (!items.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (entry.isIntersecting && !el.classList.contains("animated")) {
          const animationClass = el.dataset.animate || "fadeInUp";
          el.classList.add("animated", animationClass);

          // Apply duration and delay if provided
          if (el.dataset.duration) el.style.animationDuration = el.dataset.duration + "s";
          if (el.dataset.delay) el.style.animationDelay = el.dataset.delay + "ms";
          const countEl = el.querySelector(".count");
          const target = +el.dataset.target;
          if (countEl && target) {
            const duration = (el.dataset.duration ? parseFloat(el.dataset.duration) : 2) * 1000; // total duration in ms
            const steps = Math.min(target, 20); // maximum 20 steps
            const increment = target / steps;
            const stepTime = duration / steps;

            let current = 0;
            let stepCount = 0;

            const timer = setInterval(() => {
              stepCount++;
              current = Math.round(increment * stepCount);
              if (current >= target) {
                current = target;
                clearInterval(timer);
              }
              countEl.textContent = current.toLocaleString();
            }, stepTime);
          }
          // Stop observing after animation
          obs.unobserve(el);
        }
      });
    }, {
      threshold: 0.25,          // Trigger when 20% visible
      rootMargin: "0px 0px -10% 0px"
    });

    items.forEach(el => observer.observe(el));
  }

  // Initialize animations on page load
  initScrollAnimations();

  // Initialize for Shopify dynamic sections
  document.addEventListener("shopify:section:load", (event) => {
    initScrollAnimations(event.target);
  });
});
